import styled,{css} from 'styled-components';
import media from 'src/styles/Media.styled';

export const Container = styled.div`
    display: none;
    ${media.mobileDevice`
       display:block;
    `}
`;

export const Subtitle = styled.div`
    font-family: ${({ fontFamily }) =>
        fontFamily ? fontFamily : 'AvenirNextWorld Regular'};
    color: ${({ color }) => (color ? color : '#000000')};
    font-size: ${({ fontSize }) => (fontSize ? fontSize : '13px')};
    width: ${({ width }) => (width ? width : '100%')};
    line-height: ${({ lineHeight }) => lineHeight};
    letter-spacing: ${({ letterSpacing }) => letterSpacing};
    margin: ${({ margin }) => margin};
    ${media.mobileDevice`
       width:${({ mbWidth }) => (mbWidth ? mbWidth : '90%')};
    `};
`;

export const MainContainerItems = styled.div`
    width: ${({ width }) => (width ? width : '47%')};
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    padding: ${({ padding }) => (padding ? padding : '0rem')};
    margin-bottom: ${({ marginBottom }) =>
        marginBottom ? marginBottom : '0px'};

    ${media.largeDevice`
        width:${({ ldWidth }) => ldWidth && ldWidth};
        padding: ${({ ldPadding }) => (ldPadding ? ldPadding : '0rem')};
    `}

    ${media.mediumDevice`
        padding: ${({ mdPadding }) => (mdPadding ? mdPadding : '0rem')};
    `}

    ${media.smalDevice`
        padding: ${({ ipadPadding }) => (ipadPadding ? ipadPadding : '0.5rem')};
    `}
    ${media.mobileDevice`
        width: 100%;
        padding: ${({ mbPadding }) => (mbPadding ? mbPadding : '0rem')};     
    `}
`;

export const DisplayCard = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: stretch;
    height: 100%;
    width: 100%;
    background-color: #ffffff;
    box-shadow: 0px 0px 6px #00000029;
    border: none;
    border-radius: 6px;
    padding: ${({ padding }) => (padding ? padding : '15px 15px')};
    margin-bottom: 10px;
    ${media.mobileDevice`
    display:  ${({ display }) => (display ? display : 'flex')};
    border: 1px solid #74DED6;
    margin-bottom: 10px;
    `}
`;
export const ContainerItems = styled.div`
    width: 47%;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    margin-bottom: ${({ marginBottom }) =>
        marginBottom ? marginBottom : '0px'};
    justify-content: space-between;
    ${media.mobileDevice`
        width: 88%;   
    `}
`;

export const Value = styled.div`
    display: flex;
    font-family: 'AvenirNextWorld Regular';
    color: ${({ color }) => (color ? '#ED002A' : '#000000')};
    font-size: 16px;
    width: 90%;
    ${media.mobileDevice`
    
    `}
`;

export const Div = styled.div`
    margin: 10px 0 0 0;
    ${media.mobileDevice`
        display:none;  
    `}
`;
export const BackorderText = styled.p`
    font-family: AvenirNextWorld Demi;
    font-size: 13px;
    color: ${({ color }) => (color ? color : '#000000')};
`;

export const OrderDetailFooterContainer = styled.div`
    width: 100%;
    display: flex;
    margin: 8px 0;
    align-items: center;
    justify-content: flex-start;
`;

export const InvoiceCreatedDetail = styled.p`
    margin: ${({ margin }) => (margin ? margin : '0 5px 0 0')};
    font-family: 'AvenirNextWorld Regular';
    font-size: 10px;
    line-height: 18px;
    letter-spacing: 0px;
    color: #202124;
    opacity: 1;

    ${({ isCreatedDate }) =>
        isCreatedDate &&
        css`
            &:before,
            &:after {
                content: ' | ';
            }
        `}

    ${({ isCreatedDateBy }) =>
        isCreatedDateBy &&
        css`
            &:after {
                content: ' |';
                opacity: 20% ;
            }
        `}
          
`;

export const WrapperContainer = styled.div`
    display: flex;
    width: ${({ width }) => width};
    max-width: ${({ maxWidth }) => maxWidth};
    ${media.smalDevice`
    width: auto;
        max-width:unset;
        `}
    ${media.mobileDevice`
         width: auto;
         max-width:unset;
    `}
`;
